import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { InfoBar } from './components/InfoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'nb';
    document.title = 'GYMKLAR™ – Kroppsøving 1.–10. trinn, ferdig planlagt';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ihv048vgebg8">
      <div lang="nb" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3ml12h5fg3ihf">
        <InfoBar data-id="element-2" data-mp="3rcj31sdk3h1v" />
        <main data-id="element-3" data-mp="3rbzq6q2rjiup">
          <Hero data-id="element-4" data-mp="3rdkg22e4udm8" />
          <StatsBar data-id="element-5" data-mp="3rd19tixuhdo1" />
          <Difference data-id="element-6" data-mp="3relvsk63foaa" />
          <Recognize data-id="element-7" data-mp="6hrlipoilfp" />
          <WhatsInside data-id="element-8" data-mp="4wwnrzgd0hb" />
          <InsidePages data-id="element-9" data-mp="56mnfkhz7n0" />
          <Bonuses data-id="element-10" data-mp="7sxbo2oq39g" />
          <HowItWorks data-id="element-11" data-mp="2zllf11m4wkmq" />
          <Audience data-id="element-12" data-mp="2zm4wyibsb90r" />
          <Offer data-id="element-13" data-mp="2zmo7vf30ox5a" />
          <Guarantee data-id="element-14" data-mp="2zn66ujh2dpgw" />
          <Faq data-id="element-15" data-mp="33mf25srr5vek" />
          <FinalCta data-id="element-16" data-mp="33lwxq8uxsavk" />
        </main>
        <Footer data-id="element-17" data-mp="33n6wz1dizp3s" />
      </div>
    </MotionConfig>;
}